import TemplateLayout from "../../../../../providers/TemplateLayout";
import React from "react";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function SoloFlightOne({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [aircraftType, setAircraftType] = React.useState("");
  const [limitations, setLimitations] = React.useState("");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const templateText = `I certified that ${name} has received the required training to qualify for solo flying. I have determined [he or she] meets the applicable requirement of §61.87(n) and is proficient to make solo flights in ${aircraftType}. Limitations §61.89(a)(8): ${limitations}`;
    dispatch(setTemplateText(templateText));
  }, [name, aircraftType, limitations, dispatch]);

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: 1552.23(d)</label>
      </div>

      <div className="col-12 my-2">
        <p className="certificate_text" style={{ margin: 0 }}>
          I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received the required training to qualify for solo flying. I have determined [he or she] meets the applicable requirement of §61.87(n) and is proficient to make solo flights in
          <input
            type="text"
            onChange={(e) => setAircraftType(e.target.value)}
            placeholder="aircraft type"
            style={{ margin: '0 5px' }}
          />. Limitations §61.89(a)(8):
          <input
            type="text"
            onChange={(e) => setLimitations(e.target.value)}
            className="input_long"
            style={{ margin: '0 5px' }}
          />
        </p>
      </div>
    </TemplateLayout>
  );
}

export default SoloFlightOne;
